import { useState, useEffect, useContext } from 'react';
import { API } from '@service';
import alert from '@components/alert';
import { PopAlert } from 'appkit-react';
import {
  SocketEmit,
  SocketContext,
  SocketSubscribe,
  SocketRemoveListeners,
} from '@components/SocketProvider';
import store from '@flux/store';
import actions from '@flux/action';
import { extractReportId } from '@utils/reportIDExtracter';

function useRefreshPowerBI(projectId, link, dashboadName, identifier, type) {
  const [refreshPowerBIKey, setRefreshPowerBIKey] = useState(0);
  const [refreshBtnCountdown, setRefreshBtnCountdown] = useState(0);
  const [refreshBtnLoading, setRefreshBtnLoading] = useState(false);
  const [datasetId, setDatasetId] = useState('');
  const { socket, socketStatus } = useContext(SocketContext); // 从封装的socket里取方法
  const userInfo = JSON.parse(window.localStorage.userInfo);

  const fetchData = async () => {
    const result = await API.postIntegrationHubModule(
      {
        integrationHubModuleInfo: [{ moduleId: identifier, link }],
      },
      projectId,
    );
    if (Array.isArray(result) && result[0].reportInfo?.status === 200) {
      if (Array.isArray(result[0].reportInfo?.embedUrl)) {
        setDatasetId(result[0].reportInfo.embedUrl?.[0]?.datasetId);
      }
    }
  };

  useEffect(() => {
    if (type === 'powerbi' && Boolean(link)) {
      try {
        const url = new URL(link);
        const pathName = url.pathname.split('/') || [];
        const spaceId = pathName[2];
        const reportId = pathName[4];
        if (
          spaceId &&
          reportId &&
          pathName[1] === 'groups' &&
          pathName[3] === 'reports'
        ) {
          fetchData();
        }
      } catch (err) {
        console.log('err: ', err);
      }
    }
  }, []);

  const lockMinutes = 3;
  const setRefreshBtnCountdownWrapper = (lastRefresh) => {
    // 如果这里有上一次的刷新时间，跟当前时间做下比较（注意是UTC时间），如果上次的时间+3分钟大于现在的时间，那么就做个减法得到倒计时refreshBtnCountdown的时间
    if (
      new Date(lastRefresh).getTime() + lockMinutes * 60 * 1000 >
      new Date().getTime()
    ) {
      const resNum = Math.floor(
        (new Date(lastRefresh).getTime() +
          lockMinutes * 60 * 1000 -
          new Date().getTime()) /
          1000,
      );
      setRefreshBtnCountdown(resNum);
    }
  };

  useEffect(() => {
    if (socketStatus && datasetId) {
      SocketEmit(socket, `pbi:visitProject`, {
        app: 'ma',
        projectId,
      });
      SocketSubscribe(socket, 'pbi:refresh', ({ infoValue, email, msg }) => {
        console.log('infoValue::::', infoValue, email, msg);
        // 判断跟自己的datasetId是不是相同的，是相同的就刷新
        if (datasetId === infoValue && email !== userInfo.email) {
          setRefreshPowerBIKey(Number(new Date()));
        }
        // 按钮倒计时只需要判断infoValue与datasetId是否一致即可
        if (datasetId === infoValue && msg.infoValue) {
          // 尝试解析msg中的infoValue
          const lockInfo = JSON.parse(msg.infoValue || '{}');
          console.log('lockInfo', lockInfo);
          if (lockInfo.lastRefresh) {
            setRefreshBtnCountdownWrapper(lockInfo.lastRefresh);
          }
        }
      });

      // 监听所有的powerBI的lock time
      SocketSubscribe(socket, 'pbi:list', (data) => {
        if (data[datasetId] && data[datasetId].lastRefresh) {
          setRefreshBtnCountdownWrapper(data[datasetId].lastRefresh);
        }
      });
    }

    return () => {
      if (socketStatus && datasetId) {
        SocketEmit(socket, `pbi:leaveProject`, {
          app: 'ma',
          projectId,
        });
        SocketRemoveListeners(socket, 'pbi');
      }
    };
  }, [datasetId]);

  useEffect(() => {
    let timer;
    if (refreshBtnCountdown > 0) {
      timer = setInterval(() => {
        setRefreshBtnCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [refreshBtnCountdown]);

  const toggleRefreshPowerBI = () => {
    if (!link || !projectId) {
      return alert.error('Params error.');
    }
    setRefreshBtnLoading(true);
    // socketStatus &&
    //   SocketEmit(socket, `pbi:refresh`, {
    //     app: 'ma',
    //     // channel,
    //     projectId,
    //     infoValue: datasetId,
    //   });
    // setRefreshBtnLoading(false);
    const reportId = extractReportId(link);
    const dashboadNameID = dashboadName.replace(/ /g, '');
    const buttonID = `${reportId}_${
      identifier !== undefined ? identifier : dashboadNameID
    }`;

    API.refreshPBIDataset(projectId, { link, dashboadName, buttonID })
      .then((res) => {
        console.log('refresh powerBI res: ', res);
        setRefreshPowerBIKey(refreshPowerBIKey + 1);
        if (res?.code === 202) {
          store.dispatch(actions.triggerButton(res?.code));
          PopAlert({
            className: 'success-message-popover',
            oneLineDisplay: true,
            duration: 2000,
            status: 'success',
            message: `Dashboard refreshed successfully: ${dashboadName}`,
          });
          socketStatus &&
            SocketEmit(socket, `pbi:refresh`, {
              app: 'ma',
              // channel,
              projectId,
              infoValue: datasetId,
            });
        }
      })
      .catch((err) => {
        store.dispatch(actions.triggerButton(err));
        console.log('refresh powerBI err: ', err);
      })
      .finally((finalRes) => {
        console.log('refresh powerBI finalRes: ', finalRes);
        setRefreshBtnLoading(false);
      });
  };

  return {
    refreshPowerBIKey,
    refreshBtnLoading,
    refreshBtnCountdown,
    toggleRefreshPowerBI,
  };
}

export default useRefreshPowerBI;
